import moment from 'moment';

export const toInputFormat = (date) => moment(date).format('YYYY-MM-DD');
